// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3cMcW","content":"RecentSearches_content__3NVAN"};